<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-shared-folder`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.342 6c.647 0 1.261.312 1.676.85L21.44 10h22.115C44.906 10 46 11.015 46 12.267v29.466C46 42.985 44.906 44 43.556 44H4.444C3.094 44 2 42.985 2 41.733V8.363C2 7.059 2.977 6 4.182 6h13.16zM42 14H6v26h36V14zM13.573 35a.4.4 0 01-.373-.544C14.603 30.82 16.72 29 19.549 29c2.334 0 4.163 1.237 5.486 3.712 1.133-1.903 2.635-2.855 4.506-2.855 2.376 0 4.133 1.535 5.27 4.604a.4.4 0 01-.374.539H13.573zM29.5 23c1.636 0 2.962 1.535 2.962 3.429 0 1.893-1.326 3.428-2.962 3.428-1.636 0-2.962-1.535-2.962-3.428 0-1.894 1.326-3.429 2.962-3.429zm-10-2c1.933 0 3.5 1.79 3.5 4s-1.567 4-3.5 4-3.5-1.79-3.5-4 1.567-4 3.5-4z"/></svg>
</template>
<script>

export default {
  name: 'IconSharedFolder',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
